import { render, staticRenderFns } from "./GridLayoutWeb.vue?vue&type=template&id=252c0a11&scoped=true&"
import script from "./GridLayoutWeb.vue?vue&type=script&lang=js&"
export * from "./GridLayoutWeb.vue?vue&type=script&lang=js&"
import style0 from "./GridLayoutWeb.vue?vue&type=style&index=0&id=252c0a11&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c0a11",
  null
  
)

export default component.exports